import { API_BASE_URL } from "../config";

export const BASE_URL = API_BASE_URL;

export const routes = {
  // -----AUTH------//
  signIn: BASE_URL + "/user/login",
  logOut: BASE_URL + "/user/logout",

  // -----------Users--------------//
  getAllCustomers: BASE_URL + "/user",

  // -------------Content-------------//
  getPrivacyPolicy: BASE_URL + "/privacy",
  updatePrivacyPolicy: BASE_URL + "/privacy",
  getTermsConditions: BASE_URL + "/termsandcondition",
  updateTermsConditions: BASE_URL + "/termsandcondition",

  // -------------Chat Emojis-------------//
  getAllChatEmojis: BASE_URL + "/chat-emojis",
  createChatEmoji: BASE_URL + "/chat-emojis/create",
  deleteChatEmoji: BASE_URL + "/chat-emojis",

  // -------------AI Message Modes-------------//
  getAllAiMessageModes: BASE_URL + "/ai-message-modes",
  getAiMessageMode: BASE_URL + "/ai-message-modes",
  createAiMessageMode: BASE_URL + "/ai-message-modes",
  updateAiMessageMode: BASE_URL + "/ai-message-modes",
  deleteAiMessageMode: BASE_URL + "/ai-message-modes",
  // -------------Categories-------------//
  getAllCategories: BASE_URL + "/categories",

  // -------------Notifications-------------//
  getMyNotifications: BASE_URL + "/user/mynotifications",

  // -------------Upload-------------//
  uploadImage: BASE_URL + "/user/upload",

  // -------------FAQs-------------//
  getAllFAQs: BASE_URL + "/faq/getall",
  createFAQ: BASE_URL + "/faq/create",
  updateFAQ: BASE_URL + "/faq/update",
  deleteFAQ: BASE_URL + "/faq/delete",

  // -------------Moment Categories-------------//
  getAllMomentCategories: BASE_URL + "/moment-category",
  createMomentCategory: BASE_URL + "/moment-category/create",
  updateMomentCategory: BASE_URL + "/moment-category",
  deleteMomentCategory: BASE_URL + "/moment-category",

  // -------------SubCategories-------------//
  getAllSubCategories: BASE_URL + "/moment-sub-category",
  createSubCategory: BASE_URL + "/moment-sub-category/create",
  updateSubCategory: BASE_URL + "/moment-sub-category",
  deleteSubCategory: BASE_URL + "/moment-sub-category",

  // -------------Moments-------------//
  getAllMoments: BASE_URL + "/moment",
};
